import React, { useEffect, useState } from "react";
import { Btn } from "../../../AbstractElements";
import ReusableDropdown from "../../../Component/BasicComponents/Dropdowns/RouteDropdown";
import ReusableCheckBox from "../../../Component/BasicComponents/ReusableCheckbox";
import { useGetCurrency } from "../SuperSettingsScreen/hook/useCompony";
import {useAddOrgUnit,useGetCountryList, useGetUserConfig,useUpdateOrgUnit,} from "../MastersScreen/hooks/useSettingsMasters";
import { useGetAllPositionData } from "../../Onboarding/hooks/useOnBoard";
import PaginatedRouteDropdown from "../../../Component/BasicComponents/Dropdowns/PaginatedDropdownWrapper";
import { getAllPositionData } from "../../Onboarding/hooks/OnBoardingRepo";

interface ReqBodyInterface {
  UnitName: string;
  CurrencyId: number;
  Icountryid: number;
  CanDoCustomPlaylist: number;
  IsExposed: number;
  OrgunitAdminPosition: number;
  PunchinOnWeekoff: number;
  PunchinOnHoliday: number;
  PunchinOnLeave: number;
  // EmployeeId: number[];
  EmployeeId:null;
}


interface RowDataInterface {
  UnitName?: string;
  Scountry?: string;
  CanDoCustomPlaylist?: string; 
  IsExposed?: string;
  CurrencyId?: number;
  CountryId?: number;
  PunchinOnHoliday?: number;
  PunchinOnLeave?: number;
  PunchinOnWeekoff?: number;
  OrgunitAdminPosition?:number
  Orgunitid?:number,
  PositionName?:string
  EmployeeId:number[] 
}

interface OrgUnitTableModalContentProps {
  handleClose: () => void;
  status: string | null;
  rowData:RowDataInterface | null
}

type CheckValueState = {
  PunchIn_On_Weekoff: boolean;
  PunchIn_On_Holiday: boolean;
  PunchIn_On_Leave: boolean;
};

interface formDataInterface {
  UnitName: string;
  Currency: string | null;
  Country: string;
  Is_Exposed: string | number;
  Admin_Position: string | number;
  Can_Do_Custom_Playlist: string | number;
}

const OrgUnitTableModalContent: React.FC<OrgUnitTableModalContentProps> = ({
  rowData,
  status,
  handleClose,
}) => {
  
    
  useEffect(()=>{
     
    if(status ==='Edit'){
      setformData((prev:any)=>({
        ...prev,
        UnitName: rowData?.UnitName,
        Currency:rowData?.CountryId,
        Country: rowData?.CountryId,
        Is_Exposed: rowData?.IsExposed === 'No'? 0 : 1,
        Admin_Position:rowData?.OrgunitAdminPosition,
        Can_Do_Custom_Playlist: rowData?.CanDoCustomPlaylist === 'True' ? 1 : 0,

      }));

      setCheckValue((prev:any)=>({
             ...prev,
              PunchIn_On_Weekoff: rowData?.PunchinOnWeekoff,
              PunchIn_On_Holiday: rowData?.PunchinOnHoliday,
              PunchIn_On_Leave: rowData?.PunchinOnLeave,
      })) 
    
      setSelectedPosition((prev:any)=>({
        ...prev,
        id:rowData?.OrgunitAdminPosition,
        label:rowData?.PositionName
      }))
      
    }
   
  },[status])

  
  const { isLoading: curreneyIsloading,isSuccess: CurrencyIssuccess,data: currecncydata,} = useGetCurrency({ enable: true });
  const { isLoading: countryListLoading, isSuccess: countryListisSuccess,data: countryListData, } = useGetCountryList({ enable: true });
  const {data: userConfigData,isSuccess: isSuccessUserConfig,isLoading: isLoadingUserConfig,} = useGetUserConfig({ enable: true });
  const { mutate: addOrgUnit } = useAddOrgUnit();
  const {mutate:updateOrgUnit} = useUpdateOrgUnit();

  const [checkValue, setCheckValue] = useState<CheckValueState>({
    PunchIn_On_Weekoff: false,
    PunchIn_On_Holiday: false,
    PunchIn_On_Leave: false,
  });

  const { data: AdminPostionList } = useGetAllPositionData({
    enable: true,
    params: {
      orgUnitId: "",
      page: 1,
      limit: 10,
      search: "",
      fetch: "",
    },
  });

  //  console.log('Can_Do_Custom_Playlistposed=====>',userConfigData?.Can_Do_Custom_Playlistposed);
  //  console.log('checkValue=====> Inital ',checkValue);

  const [formData, setformData] = useState<formDataInterface>({
    UnitName: "",
    Currency: null,
    Country: "",
    Is_Exposed: "",
    Admin_Position: "",
    Can_Do_Custom_Playlist: "",
  });

  const [selectedPosition, setSelectedPosition] = useState<{id: number;label: string;} | null>(null);

  const checkboxOptions = [
    {
      label: "PunchIn On Weekoff",
      value: "PunchIn_On_Weekoff",
      checked: checkValue.PunchIn_On_Weekoff,
    },
    {
      label: "PunchIn On Holiday",
      value: "PunchIn_On_Holiday",
      checked: checkValue.PunchIn_On_Holiday,
    },
    {
      label: "PunchIn On Leave",
      value: "PunchIn_On_Leave",
      checked: checkValue.PunchIn_On_Leave,
    },
  ];

  const handleCheckedChange = (checkedItems: string[]) => {
    setCheckValue((prev) => {
      const updated = { ...prev };
      (Object.keys(updated) as Array<keyof CheckValueState>).forEach((key) => {
        updated[key] = checkedItems.includes(key);
      });
      return updated;
    });
  };
  const handleInput = (kay: any, value: any) => {
    setformData((prev: any) => ({
      ...prev,
      [kay]: value,
    }));
  };


  console.log('Data?.EmployeeId',typeof(rowData?.EmployeeId));

  const handleSubmit = (e: React.ChangeEvent<HTMLFormElement>) => {
    e.preventDefault(); 
    
    // const EmployeeIdArray :number[]= [Number(rowData?.EmployeeId)];

    // console.log('EmployeeIdArray===>',typeof(EmployeeIdArray))
    // console.log('EmployeeIdArray',Array.isArray(EmployeeIdArray)); // true
    // console.log('first',EmployeeIdArray.length)

    const ReqBody: ReqBodyInterface = {
        UnitName: formData.UnitName,
        CurrencyId: Number(formData.Currency),
        Icountryid: Number(formData.Country),
        CanDoCustomPlaylist: Number(formData.Can_Do_Custom_Playlist),
        IsExposed: Number(formData.Is_Exposed),
        OrgunitAdminPosition: Number(selectedPosition?.id),
        PunchinOnWeekoff: checkValue.PunchIn_On_Weekoff === false ? 0 : 1,
        PunchinOnHoliday: checkValue.PunchIn_On_Holiday === false ? 0 : 1,
        PunchinOnLeave: checkValue.PunchIn_On_Leave === false ? 0 : 1,
        // EmployeeId:[Number(rowData?.EmployeeId)]
        // EmployeeId: rowData?.EmployeeId ?[Number(rowData?.EmployeeId)] : []
        // EmployeeId: rowData?.EmployeeId !== undefined && rowData?.EmployeeId !== null
        // ? [Number(rowData.EmployeeId)]
        // : []
        // EmployeeId:EmployeeIdArray.length> 1 ? EmployeeIdArray :[]
        EmployeeId:null
      };

    if (status === "Add") {
      addOrgUnit(ReqBody);
    }
    
    if(status ==='Edit'){
      const OrgUnit_ID = Number(rowData?.Orgunitid);
      console.log('ReqBody=======>',ReqBody);

      updateOrgUnit({ReqBody:ReqBody,id:OrgUnit_ID})
    }

    handleClose();

    setformData({
      UnitName: "",
      Currency: null,
      Country: "",
      Is_Exposed: "",
      Admin_Position: "",
      Can_Do_Custom_Playlist: "",
    });

  };

  return (
    <form onSubmit={handleSubmit}>
      {/* First Input */}
      <div className="row mb-3">
        <div className="col-md-6">
          <label style={{ fontWeight: "500" }}>Unit Name<span style={{color:"red"}}>*</span> </label>
          <input
            value={formData.UnitName}
            type="text"
            required
            className="form-control"
            placeholder="Enter category name"
            onChange={(e:React.ChangeEvent<HTMLInputElement>) =>
              handleInput("UnitName", e.target.value)
            }
            style={{
              border: "2px solid #EDEDED",
              borderRadius: "8px",
              padding: "13px",
              fontSize: "14px",
              width: "100%",
            }}
          />
        </div>
        <div className="col-md-6">
          <ReusableDropdown
            value={formData.Currency || []}
            options={
              (!curreneyIsloading &&
                CurrencyIssuccess &&
                currecncydata.formateData) ||
              []
            }
            onChange={(value: any) => handleInput("Currency", value)}
            DropdownHeading="Currency"
          />
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-md-6">
          <ReusableDropdown
            value={formData.Country}
            options={
              (!countryListLoading &&
                countryListisSuccess &&
                countryListData?.formateData) ||
              []
            }
            onChange={(value: any) => handleInput("Country", value)}
            DropdownHeading="Country"
          />
        </div>

        <div className="col-md-6">
          <ReusableDropdown
            value={formData.Can_Do_Custom_Playlist}
            options={
              (!isLoadingUserConfig &&
                isSuccessUserConfig &&
                userConfigData?.Can_Do_Custom_Playlistposed) ||
              []
            }
            onChange={(value: any) =>
              handleInput("Can_Do_Custom_Playlist", value)
            }
            DropdownHeading="Can Do Custom Playlist"
          />
        </div>
      </div>
      <div className="row mb-3">
        <div className="col-md-6">
          <ReusableDropdown
            value={formData.Is_Exposed}
            options={
              (!isLoadingUserConfig &&
                isSuccessUserConfig &&
                userConfigData?.Is_Exposed) ||
              []
            }
            onChange={(value: any) => handleInput("Is_Exposed", value)}
            DropdownHeading="Is Exposed"
          />
        </div>
        <div className="col-md-6">
          <PaginatedRouteDropdown
            DropdownHeading=" Admin Position"
            initialSelectedOptions={selectedPosition} // ✅ Only for showing selected
            onChange={(val: any) => {
              // ✅ You must get { id, label } back (see fix below in component)
              setSelectedPosition(val);
            }}
            fetchOptions={async (page: any, search: any) => {
              const res = await getAllPositionData({
                search: search || "",
                page,
                limit: 10,
                orgUnitId: "",
                fetch: "",
              });

              // console.log("res::::::::::", res);
              return res?.data?.Positions?.map((item: any) => ({
                id: item?.PositionId,
                label: item?.PositionName,
              }));
            }}
          />
        </div>
      </div>
      <div className="col-md-6">
        <ReusableCheckBox
          data={checkboxOptions}
          onCheckedChange={handleCheckedChange}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: "10px",
          }}
        />
      </div>

      {/* Buttons */}
      <div className="d-flex justify-content-start mt-3 gap-2">
        <Btn
          style={{ backgroundColor: "#43B9B2", color: "white" }}
          type="submit"
        >
          Submit
        </Btn>
        <Btn
          style={{
            backgroundColor: "#F9FAFC",
            color: "#000",
            border: "1px solid #E0E0E0",
          }}
          type="button"
          onClick={handleClose}
        >
          Cancel
        </Btn>
      </div>
    </form>
  );
};

export default OrgUnitTableModalContent;
